const __WEBPACK_NAMESPACE_OBJECT__ = require("plugin-assets/shared/test-tools/multi-channel-test-tools-registry");